module.exports = __webpack_public_path__ + "static/media/brinton-101.a299a40c.jpg";